/*//////////////////////*/
/* Exports
/*/ /////////////////////*/

export const getLotReducer = (state) => state.lot;

export const getVideoResult = (typology, videoID) => (state) => {
  return state.lot[`${typology}Medias`].find((video) => video.id === +videoID);
};
